import { connect } from 'react-redux';
import { getIsUnverified, getVerificationLoadingState, } from '../../../publicSession/selectors';
import { resendVerificationEmail } from '../../../publicSession/actions';
var mapStateToProps = function (state) { return Object.assign({}, getVerificationLoadingState(state), {
    isUnverified: getIsUnverified(state)
}); };
var mapDispatchToProps = {
    resendEmail: resendVerificationEmail,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=VerificationReminder.container.js.map